import type { ZodSchema } from 'zod';

export type FormErrors<T> = Partial<Record<keyof T, string>>;

export function validateWithSchema<T>(schema: ZodSchema<T>, values: T): { success: true; data: T } | { success: false; errors: FormErrors<T> } {
  const result = schema.safeParse(values);

  if (result.success) {
    return { success: true, data: result.data };
  }

  const fieldErrors: FormErrors<T> = {};

  for (const issue of result.error.issues) {
    const field = issue.path[0];
    if (typeof field === 'string') {
      fieldErrors[field as keyof T] = issue.message;
    }
  }

  return { success: false, errors: fieldErrors };
}

